// extracted by mini-css-extract-plugin
export default {"auth-container":"AuthForm_auth-container__OjqUp","auth-box":"AuthForm_auth-box__JSpUM","auth-logo":"AuthForm_auth-logo__92deA"};